import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { getVendorStatus } from '../services/subscriptionService';
import { isVendorPathAllowed, resolvePlanAccessKeyFromPath } from '../utils/vendorPlanAccess';

const useVendorPlanAccess = () => {
  const { user } = useAuth();
  const isVendor = user?.user_type === 'vendor';

  const { data, isLoading } = useQuery({
    queryKey: ['vendor-plan-access'],
    queryFn: getVendorStatus,
    enabled: isVendor,
    staleTime: 60 * 1000,
  });

  const currentSubscription = data?.data?.current_subscription ?? null;
  const vendorPageAccess = currentSubscription?.vendor_page_access ?? null;
  const isFreeTier = Boolean(currentSubscription?.is_free_tier);
  const currentPlanSlug = currentSubscription?.plan_slug ?? null;

  const canAccessPath = (pathname) => isVendorPathAllowed(pathname, vendorPageAccess);
  const canAccessKey = (key) => {
    if (!Array.isArray(vendorPageAccess) || vendorPageAccess.length === 0) return true;
    return vendorPageAccess.includes(key);
  };

  return {
    isLoading: isVendor ? isLoading : false,
    vendorPageAccess,
    currentSubscription,
    isFreeTier,
    currentPlanSlug,
    canAccessPath,
    canAccessKey,
    resolvePlanAccessKeyFromPath,
  };
};

export default useVendorPlanAccess;

